export const TOAST_TYPES = {
  success: 'success',
  error: 'error',
  info: 'info',
};

export const TOAST_TIMEOUT = 5000;
export const TOAST_UNEXPECTED_ERROR_TITLE = 'uiMessages.error';
export const TOAST_UNEXPECTED_ERROR_MESSAGE = 'uiMessages.errorMessage';
